// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"71ccede5","644":"f14b0a47","732":"ec63a4bf"}[chunkId] + ".chunk.js";
};